module.exports = __webpack_public_path__ + "img/card_Dash_blue-min.c7f255f1.png";